<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="待打印发货单唛头">
        <wait-print ref="waitPrintRef" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="已打印发货单唛头">
        <already-print ref="alreadyPrintRef" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import waitPrint from './waitPrint';
import alreadyPrint from './alreadyPrint';

export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    waitPrint,
    alreadyPrint
  },

  computed: {
    tabsActive: {
      get () {
        return '1';
      },
      set (val) {
        val === '2' && this.$refs.waitPrintRef.resetForm();
        val === '1' && this.$refs.alreadyPrintRef.resetForm();
      }
    }
  }
};
</script>
